webpackJsonp([35783957827783],{

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _googleStoreImage = __webpack_require__(33);
	
	var _googleStoreImage2 = _interopRequireDefault(_googleStoreImage);
	
	var _iOSStoreImage = __webpack_require__(25);
	
	var _iOSStoreImage2 = _interopRequireDefault(_iOSStoreImage);
	
	var _elmAccCover = __webpack_require__(422);
	
	var _elmAccCover2 = _interopRequireDefault(_elmAccCover);
	
	var _elmAccApp = __webpack_require__(103);
	
	var _elmAccApp2 = _interopRequireDefault(_elmAccApp);
	
	var _elmAccAudio = __webpack_require__(421);
	
	var _elmAccAudio2 = _interopRequireDefault(_elmAccAudio);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _storeLinks = __webpack_require__(21);
	
	var _storeLinks2 = _interopRequireDefault(_storeLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var title = "Elm Accelerated";
	
	var Formats = function Formats() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'formats' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'The Book'
	      ),
	      _react2.default.createElement('img', { src: _elmAccCover2.default, style: { paddingBottom: 38 } }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Like something traditional? A concise, clear introduction to Elm and its core libraries.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The books are free and should work great on e-readers like a Kindle.'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://s3.eu-west-2.amazonaws.com/elm-accelerated-downloads/ElmAccelerated.epub', alt: title + ' epub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'webLink' },
	          'ePub'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://s3.eu-west-2.amazonaws.com/elm-accelerated-downloads/ElmAccelerated.mobi', alt: title + ' mobi' },
	        _react2.default.createElement(
	          'div',
	          { className: 'webLink' },
	          'Mobi'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'The App'
	      ),
	      _react2.default.createElement('img', { src: _elmAccApp2.default }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'An innovative approach to learning programming. The App has over one hundred flash cards and tracks your fluency at each.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'It includes the full book text so you can look up anything you are struggling with. Don\'t just learn Elm, get fluent at it.'
	      ),
	      _react2.default.createElement(_storeLinks2.default, { iOSStoreLink: 'https://itunes.apple.com/us/app/elm-accelerated/id1303935533?ls=1&mt=8' })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'The Audio Book'
	      ),
	      _react2.default.createElement('img', { src: _elmAccAudio2.default }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'A 10 or so minute summary of the key points from Elm Accelerated. Set to repeat?'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://s3.eu-west-2.amazonaws.com/elm-accelerated-downloads/ElmAcceleratedAudio.zip', alt: title + ' in Audio' },
	        _react2.default.createElement(
	          'div',
	          { className: 'webLink' },
	          'MP3'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        { style: { paddingTop: 28 } },
	        'Even More'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Do a quick online Elm quiz or see sample chapters and resources.'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/elm', className: 'main-button elm-bg', style: { margin: 5 } },
	        'Quiz, sample chapters and resources on Elm'
	      )
	    )
	  );
	};
	
	exports.default = Formats;
	module.exports = exports['default'];

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _iOSStoreImage = __webpack_require__(25);
	
	var _iOSStoreImage2 = _interopRequireDefault(_iOSStoreImage);
	
	var _typescriptAccCover = __webpack_require__(423);
	
	var _typescriptAccCover2 = _interopRequireDefault(_typescriptAccCover);
	
	var _tsAccApp = __webpack_require__(104);
	
	var _tsAccApp2 = _interopRequireDefault(_tsAccApp);
	
	var _tsAccApp3 = __webpack_require__(105);
	
	var _tsAccApp4 = _interopRequireDefault(_tsAccApp3);
	
	var _storeLinks = __webpack_require__(21);
	
	var _storeLinks2 = _interopRequireDefault(_storeLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var title = "TypeScript Accelerated";
	
	var Formats = function Formats() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'formats' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'The Book'
	      ),
	      _react2.default.createElement('img', { src: _typescriptAccCover2.default, style: { paddingBottom: 38 } }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Like something traditional? A concise, clear introduction to TypeScript.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The books are free and should work great on e-readers like a Kindle.'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://s3.eu-west-2.amazonaws.com/elm-accelerated-downloads/TypeScriptAccelerated.epub', alt: title + ' epub' },
	        _react2.default.createElement(
	          'div',
	          { className: 'webLink' },
	          'ePub'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://s3.eu-west-2.amazonaws.com/elm-accelerated-downloads/TypeScriptAccelerated.mobi', alt: title + ' mobi' },
	        _react2.default.createElement(
	          'div',
	          { className: 'webLink' },
	          'Mobi'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'The App'
	      ),
	      _react2.default.createElement('img', { src: _tsAccApp4.default }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'An innovative approach to learning programming. The App has over 50 flash cards and tracks your fluency at each individually. When you have a few minutes spare the App allows you to quickly drill flash cards, focusing on those you are struggling with.'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('img', { src: _tsAccApp2.default, style: { paddingTop: 78 } }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'It includes the full book text so you can look up anything you are struggling with. Don\'t just learn TypeScript, get fluent at it.'
	      ),
	      _react2.default.createElement(_storeLinks2.default, { iOSStoreLink: 'https://itunes.apple.com/us/app/typescript-accelerated/id1404381952?ls=1&mt=8' })
	    )
	  );
	};
	
	exports.default = Formats;
	module.exports = exports['default'];

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _googleStoreImage = __webpack_require__(33);
	
	var _googleStoreImage2 = _interopRequireDefault(_googleStoreImage);
	
	var _iOSStoreImage = __webpack_require__(25);
	
	var _iOSStoreImage2 = _interopRequireDefault(_iOSStoreImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StoreLinks = function StoreLinks(_ref) {
	  var androidStoreLink = _ref.androidStoreLink,
	      iOSStoreLink = _ref.iOSStoreLink,
	      leanpubLink = _ref.leanpubLink,
	      amazonLink = _ref.amazonLink,
	      title = _ref.title;
	  return _react2.default.createElement(
	    'div',
	    { className: 'store-links' },
	    iOSStoreLink && _react2.default.createElement(
	      'a',
	      { href: iOSStoreLink },
	      _react2.default.createElement('img', { src: _iOSStoreImage2.default, alt: 'Download ' + title + ' from Apple App Store', style: { width: 135, height: 40 } })
	    ),
	    androidStoreLink && _react2.default.createElement(
	      'a',
	      { href: androidStoreLink },
	      _react2.default.createElement('img', { src: _googleStoreImage2.default, alt: 'Download ' + title + ' from Google Play', style: { width: 135, height: 40 } })
	    ),
	    leanpubLink && _react2.default.createElement(
	      'a',
	      { href: leanpubLink, alt: '' + title },
	      _react2.default.createElement(
	        'div',
	        { className: 'webLink' },
	        'On Leanpub'
	      )
	    ),
	    amazonLink && _react2.default.createElement(
	      'a',
	      { href: amazonLink, alt: '' + title },
	      _react2.default.createElement(
	        'div',
	        { className: 'webLink' },
	        'On Kindle'
	      )
	    )
	  );
	};
	
	exports.default = StoreLinks;
	module.exports = exports['default'];

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/app-tour.7235f644.png";

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/elm-acc-app.1562e76d.png";

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/elm-acc-audio.1ea1d83d.png";

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/elm-acc-cover.ef0fe23b.png";

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/googleStoreImage.7a60f99f.png";

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ts-acc-app.a1ab691b.png";

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ts-acc-app2.83a035bc.png";

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/typescript-acc-cover.a3ef43fa.png";

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _storeLinks = __webpack_require__(21);
	
	var _storeLinks2 = _interopRequireDefault(_storeLinks);
	
	var _IntroParagraph = __webpack_require__(48);
	
	var _IntroParagraph2 = _interopRequireDefault(_IntroParagraph);
	
	var _appTour = __webpack_require__(420);
	
	var _appTour2 = _interopRequireDefault(_appTour);
	
	var _Formats = __webpack_require__(179);
	
	var _Formats2 = _interopRequireDefault(_Formats);
	
	var _FormatsTS = __webpack_require__(180);
	
	var _FormatsTS2 = _interopRequireDefault(_FormatsTS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Welcome'
	    ),
	    _react2.default.createElement(_IntroParagraph2.default, null),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'The Series'
	    ),
	    _react2.default.createElement(
	      'h2',
	      { className: 'elm' },
	      'TypeScript Accelerated'
	    ),
	    _react2.default.createElement('p', null),
	    _react2.default.createElement(_FormatsTS2.default, null),
	    _react2.default.createElement(
	      'h2',
	      { className: 'elm' },
	      'Elm Accelerated'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Elm is an extraordinary language and ecosystem for building complex front end web applications. While Elm takes ideas from the academic world of functional programming, it applies them in a pragmatic way to allow you to create web apps which not only never crash but are also amazingly maintainable. Out of the box you get an amazing compiler (which is more like a hyper intelligent pair programmer), a React-like virtual DOM, a Redux-like way of modeling state (but with so much less boilerplate and much more help from tooling).'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'While Elm is incredibly solid and ready for production use (I\'ve used it on two substantial, shipped projects) it is a bit lacking in learning resources. Elm Accelerated is a set of resources including an App, Book and more. The App, via flash cards, tracks your fluency on various topics and offers quick access to explanations for anything you are struggling with.'
	    ),
	    _react2.default.createElement(_Formats2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-7bc8b93460d7a00c197a.js